import request from '@/utils/request'

// 查询商品库存列表
export function queryProductStock(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productStock/queryProductStock',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存商品库存
export function saveProductStock(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productStock/saveProductStock',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除商品库存
export function deleteProductStock(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productStock/deleteProductStock',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品信息
export function listProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/listProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}